<template>
      <v-container class="py-0 header-class">
         <div>
            <img class="farm-logo-img"
               style="vertical-align:bottom"
               :src="profile.logoURL"
            />
            <span class="title mx-6 my-3 black--text">{{profile.name}}</span>
            <!-- <div class="break"></div> -->
         </div>
         <p class="subheader">{{subtitle}}</p>
      </v-container>
</template>

<script>
export default {
   name: "printHeader",
   props: {
      subtitle: {
         type: String,
         default: "",
         required: false
      },
   },
   data() {
      return {
      }
   },
   computed: {
      profile() {
         return this.$store.getters.getProfile;
      }
   },
}
</script>

<style scoped>
   .header-class {
      display: flex;
      align-content: center;
      justify-content: flex-start;
      flex-wrap: wrap;
   }
   .break {
      flex-basis: 100%;
      height: 0;
   }
   .farm-logo-img {
      display: inline-block;
      max-height: 60px;
      width: auto;
      margin-left: 10px;
      align-self: center;
   }

</style>